import type { QueryClient } from "@tanstack/react-query";
import { createResourceStorageKeys } from "src/framework/createResourceStorageKeys.ts";
import { memoryStorageDriver } from "src/storage/memoryStorage.driver.ts";
import {
  getResourceFormSavedScrollPositionKey,
  savedScrollPositions,
} from "src/system/savedScrollPositions.ts";
import { createModuleQueries } from "src/framework/createModuleQueries.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const clearEditResourceFormState = ({
  resource,
  id,
  queryClient,
}: {
  resource: string;
  queryClient: QueryClient;
  id: string;
}) => {
  const storageKeys = createResourceStorageKeys({
    resource,
  });
  const storageKey = storageKeys.form({
    id: id,
    type: "edit",
  });
  const langStorageKey = storageKeys.formLang({
    id: id,
    type: "edit",
  });
  memoryStorageDriver.remove(storageKey);
  memoryStorageDriver.remove(langStorageKey);
  delete savedScrollPositions[
    getResourceFormSavedScrollPositionKey({
      resource,
      id: id,
      action: "edit",
    })
  ];
  const queryKeys = createModuleQueries();
  queryClient.removeQueries({
    queryKey: queryKeys.detail({
      resource,
      id: id,
    }),
  });

  if (resource === ResourceEnum.Product) {
    // todo: close all product variants
  }
  if (resource === ResourceEnum.PriceList) {
    // todo: close all price list exceptions
  }
};
